import { Common } from "@common/types";

let appInfo: Common.AppInfo = {
  ai: {
    agentId: null,
    creditBalance: 0,
    isTextGenerationEnabled: false
  },
  awsBaseUrl: "",
  billingCurrencyCode: "",
  bunny: null,
  business: {
    timeZone: "UTC",
    timeZoneIana: "",
    unitStandardKey: "Metric"
  },
  host: {
    bunnyLibraryId: "",
    publicUrl: "",
    url: ""
  },
  installedApps: [],
  integration: {
    hostUrl: "",
    mediaServiceUrl: ""
  },
  countryCode: "",
  cultureCode: "",
  currencyCode: "",
  isMultiCurrency: false,
  isWalletToWalletTransfersEnabled: false,
  primaryCultureCode: "",
  system: {
    brandDomain: "",
    brandKey: "Funnelr",
    company: null,
    createdOnDate: "",
    defaultSendingEmail: "",
    id: "",
    isDemo: false,
    isHost: false,
    liveRootDomain: "",
    statusKey: "Active",
    prefix: "",
    upgradedOnDate: null,
    version: ""
  },
  user: null
};

export const patchAppInfo = (info: Partial<Common.AppInfo>) => {
  Object.assign(appInfo, info);
};

export const patchAppInfoUser = (user: Partial<Common.AppConfigUser>) => {
  if (!appInfo.user) throw new Error("BUG");

  Object.assign(appInfo.user, user);
};

export const userHasPermission = (permission: string) =>
  !!appInfo.user?.isSuperUser || appInfo.user?.permissionKeys?.includes(permission);

export default appInfo;

export const isStaffOrSuperUser = () => !!appInfo.user?.isStaff || !!appInfo.user?.isSuperUser;

export const isExpomarket = () => appInfo.system.brandKey === "Expomarket";
export const isNetready = () => appInfo.system.brandKey === "Netready";
export const isFunnelr = () => appInfo.system.brandKey === "Funnelr";
